async function initMap() {
    // The location of map center
    const position = { lat: 41.919037, lng: 8.743517 };
    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerView } = await google.maps.importLibrary("marker");

    var mapSAV = document.getElementById('map');
    var bounds = new google.maps.LatLngBounds();
    var stores = JSON.parse(mapSAV.getAttribute('data-markers'));

    // The map centered
    map = new Map(document.getElementById("map"), {
        zoom: 4,
        center: position,
        mapId: "2b8a62cd35548049",
    });

    //Infowindow
    const infoWindow = new google.maps.InfoWindow();


    //The markers
    var markers = [];
    for (let [i, store] of stores.entries()) {
        var gps = store.gps.split(',');
        var coordinnates = new google.maps.LatLng(JSON.parse(gps[0].trim()), JSON.parse(gps[1].trim()));

        const AdvancedMarkerElement = new google.maps.marker.AdvancedMarkerElement({
            map,
            content: buildContent(store),
            position: coordinnates,
            title: store.nom,
        });
        
        AdvancedMarkerElement.addListener("gmp-click", () => {
            toggleHighlight(AdvancedMarkerElement, store);
        });

        bounds.extend(coordinnates);
        markers[i] = AdvancedMarkerElement;
    }

    // cluster
    const renderer = {
        render: ({ count, position }) =>
        new google.maps.Marker({
            position: {
                lat: position.lat(),
                lng: position.lng(),
            },
            icon: {
              url: 'https://cdn.shopify.com/s/files/1/0692/5303/8324/files/icon_cluster-ED_72x_14f585cc-b3c6-47cc-ac10-9a2c59bc4114.webp?v=1719842977',
              scaledSize: new google.maps.Size(40, 40),
            },
            label: String(count),
        })
    };
    new markerClusterer.MarkerClusterer({
        markers,
        map,
        renderer
    });

    // infowindow
    function toggleHighlight(markerView, store) {
        if (markerView.content.classList.contains("highlight")) {
          markerView.content.classList.remove("highlight");
          markerView.zIndex = null;
        } else {
          markerView.content.classList.add("highlight");
          markerView.zIndex = 1;
        }
    }

    function buildContent(store) {
        const content = document.createElement("div");
        content.classList.add("storeContent");

        tempHTML = '<div class="icon"><img src="' + store.marker + '" /></div>';
        tempHTML += '<div class="details">';
        tempHTML += '<div class="heading">';
        tempHTML += '<span class="h3">' + store.nom + '</span><img class="close" src="https://cdn.shopify.com/s/files/1/0692/5303/8324/files/close.svg?v=1718267004"/>';
        tempHTML += '</div>';
        if (store.address != "") {
            tempHTML += '<div class="info address"><img src="https://cdn.shopify.com/s/files/1/0692/5303/8324/files/adresse.svg?v=1718266677"/>' + store.address + '</div>';
        }
        if (store.tel != "") {
            tempHTML += '<div class="info tel"><img src="https://cdn.shopify.com/s/files/1/0692/5303/8324/files/telephone.svg?v=1718267004"/>' + store.tel + '</div>';
        }
        if (store.email != "") {
            tempHTML += '<div class="info email"><img src="https://cdn.shopify.com/s/files/1/0692/5303/8324/files/e-mail.svg?v=1718267004"/>' + store.email + '</div>';
        }
        tempHTML += '<a class="button button--primary" href="/pages/store-locator/'+ store.slug +'">Afficher</a>';
        tempHTML += '</div>';

        content.innerHTML = tempHTML;
          
        return content;
    }

    map.fitBounds(bounds);

}

initMap();